export default {
    MALE: 0,
    FEMALE: 1,
    DIVERSE: 2
}
